import { Button, Modal } from '@shared/widgets';

interface ISuccessForgotModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SuccessForgotModal = (props: ISuccessForgotModalProps) => {
  return (
    <Modal title='Your details have been sent' isOpen={props.isOpen} onClose={props.onClose}>
      <p className='max-md:text-[#4c4c4c80]'>
        Please note that your username has been sent to your email address. If you have any further questions, please contact the call centre team on
        the number below:
      </p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-[#000]'>24-hour phone support:</p>
        <p className='text-[#000]'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={props.onClose}>
        Ok
      </Button>
    </Modal>
  );
};
